module.exports = __webpack_public_path__ + "img/tooltip_04-vallone-murale-round.82efd77d.jpg";